import { render, staticRenderFns } from "./GiftCardTicketBoxChangeBtn.vue?vue&type=template&id=1a55814a&"
import script from "./GiftCardTicketBoxChangeBtn.vue?vue&type=script&lang=js&"
export * from "./GiftCardTicketBoxChangeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports